import { notification } from "antd";
import Helper from "../../Helper";
import { Material } from "../../models/Material";
import { ProcurementFilter } from "../../models/ProcurementFilter";
import { plotFetch } from "../Helper/ApiRequest";

export function getProjectMaterials(
    team_subdomain: string,
    project_token: string,
    filterInfo: ProcurementFilter,
    timezone: string,
    material_ids?: number[],
    archived?: boolean
): Promise<Material[]> {
    const url = new URL(`
    ${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/materials?archived=${archived ? true : false}`);

    if (material_ids) {
        url.searchParams.append("material_ids", material_ids.toString());
    }

    const filterUrl = filterInfo.appendedToUrl(url);

    return plotFetch(filterUrl.toString(), { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response.map((material_group: any) => Material.fromApiObject(material_group, timezone));
        })
        .catch((error) => {
            return [];
        });
}

export function createMaterial(
    team_subdomain: string,
    project_token: string,
    material: Material,
    timezone: string
): Promise<Material | null> {
    const url =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        "/projects/" +
        project_token +
        "/materials";

    return plotFetch(
        url,
        {
            method: "POST",
            body: JSON.stringify({ material: material.toApiObject() }),
        },
        true
    )
        .then((data) => {
            if (data.ok) {
                return data.json();
            }
            throw new Error("Network error.");
        })
        .then((data) => {
            return Material.fromApiObject(data, timezone);
        })
        .catch(() => {
            return null;
        });
}

export function updateMaterial(
    team_subdomain: string,
    project_token: string,
    material: Material,
    timezone: string
): Promise<Material | null> {
    const url =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        "/projects/" +
        project_token +
        "/materials/" +
        material.id;

    return plotFetch(
        url,
        {
            method: "PUT",
            body: JSON.stringify({ material: material.toApiObject() }),
        },
        true
    )
        .then((data) => {
            if (data.ok) {
                return data.json();
            }
            throw new Error("Network error.");
        })
        .then((data) => {
            return Material.fromApiObject(data, timezone);
        })
        .catch(() => {
            return null;
        });
}

export function deleteMaterial(team_subdomain: string, project_token: string, material: Material): Promise<boolean> {
    const url =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        "/projects/" +
        project_token +
        "/materials/" +
        material.id;

    return plotFetch(url, { method: "DELETE" }, true)
        .then((data) => {
            if (data.ok) {
                notification.success({
                    message: "Material Archived",
                    description: "The material has been archived successfully.",
                    duration: 2,
                });
                return true;
            }
            throw new Error("Network error.");
        })
        .catch(() => {
            return false;
        });
}

export function updateMaterialSync(
    team_subdomain: string,
    project_token: string,
    material: Material,
    options: ("submit_date" | "approval_date")[] = []
): Promise<boolean> {
    const url =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        "/projects/" +
        project_token +
        "/materials_sync/" +
        material.id;

    return plotFetch(url, { method: "PUT", body: JSON.stringify({ options: options }) }, true)
        .then((data) => {
            if (data.ok) {
                return true;
            }

            throw new Error("Network error.");
        })
        .catch(() => {
            return false;
        });
}
